import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const propTypes = {
  dealer: PropTypes.shape().isRequired
}

const DealerMarker = ({ dealer }) => {
  return (
    <>
      <S.DealerName>{dealer.dealerName}</S.DealerName>
      <S.DealerInfo>{dealer.address}</S.DealerInfo>
      <S.DealerInfo>{dealer.city} ,{dealer.state} {dealer.zip}</S.DealerInfo>
    </>
  )
}

export default DealerMarker

DealerMarker.propTypes = propTypes

const S = {
  DealerInfo: styled.div`
    font-size: 15px;
    line-height: 20px;
`,
  DealerName: styled.div`
    font-size: 21px;
    font-weight: normal;
`
}
